import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {VirtualMetricOPEEnum} from "./VirtualMetricOPEEnum";
import {DataUnit} from "../../models/data-unit/DataUnit";
import {VMResettableConfig, VMScheduledConfig, VMTypeEnum} from "../../models/virtualmetric/VirtualMetric";

class O {
  virtualMetrics!: VisualMetricDTO[];
}

class VisualMetricDTO {

  id!: number;

  name!: string;

  enabled!: boolean;

  isBool!: boolean;

  type!: VMTypeEnum;

  expression!: string;

  dataUnit!: DataUnit;

  decimalDigits!: number;

  scheduledConfig!: VMScheduledConfig;

  resettableConfig!: VMResettableConfig;

}

/**
 * O Inner Class
 */
class I {
  partitionId!: number;
}

export class GetVirtualMetricsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(VirtualMetricOPEEnum.GetVirtualMetrics);
    this.i = new I();
    this.o = new O();
  }
}
